import React, { useEffect, useState } from 'react'
import "./productmgmt.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal } from "react-bootstrap";
const Productmgmt = () => {
  const [modalAddProduct, setModalAddProduct] = useState(false);
  const [product, setProduct] = useState([])
  const [originalProduct, setOriginalProduct] = useState([]) 
  const [edit, setEdit] = useState(false)
  const [ProductId, setProductId] = useState("")
  const [colorlist, setcolorlist] = useState([
    {
      color: "Charcoal black",
      colorCode: "#000000",
      secondary: "#000000",
    }, {
      color: "Artic white",
      colorCode: "#d8d8d8",
      secondary: "#d8d8d8",
    }, {
      color: "Ash grey",
      colorCode: "#6d6d6d",
      secondary: "#6d6d6d",
    }, {
      color: "Classic Maroon",
      colorCode: "#830B00",
      secondary: "#830B00",
    },
    {
      color: "Noir white",
      colorCode: "#F0F0F0",
      secondary: "#000000",
    }
  ])
  const [colorPallete, setColorPallete] = useState([
    {
      color: "Charcoal black",
      colorCode: "#000000",
      secondary: "#000000",

    }, {
      color: "Urban Oak",
      colorCode: "#6d4d33",
      secondary: "#000000",

    }, {
      color: "Midnight Grey",
      colorCode: "#535353",
      secondary: "#000000",

    }, {
      color: "Arctic white",
      colorCode: "#d8d8d8",
      secondary: "#d8d8d8",

    }, {
      color: "Ash grey",
      colorCode: "#6d6d6d",
      secondary: "#6d6d6d",

    }, {
      color: "Noir white",
      colorCode: "#F0F0F0",
      secondary: "#000000",

    }, {
      color: "Caramel Brown",
      colorCode: "#A47141",
      secondary: "#A47141",

    }, {
      color: "Cocoa Brown",
      colorCode: "#4A2413",
      secondary: "#4A2413",

    }, {
      color: "Blanca Brown",
      colorCode: "#F0F0F1",
      secondary: "#4A2413",

    }, {
      color: "Luxe Grey",
      colorCode: "#8E8E8E",
      secondary: "#F0F0F0",

    }
  ])

  const [sweepSize, setSweepSize] = useState([
    {
      size: "900mm",
    }, {
      size: "1200mm",
    }, {
      size: "1400mm",
    }
  ])
  const [productType, setProductType] = useState("fan")
  const [activeColorCode, setActiveColorCode] = useState("#000000")
  const [activeSize, setActiveSize] = useState("900mm")

  const handlecolor = (colorCode) => {
    if (productType === "led-bulb") {
      setActiveColorCode(colorCode)
    } else {
      if (colorCode == "#000000") {
        setProductfor("Dark Edition")
      } else {
        setProductfor("Normal")
      }
      setActiveColorCode(colorCode)
    }

  }
  const handleSize = (size) => {
    setActiveSize(size)
  }

  const [category, setCategory] = useState("")
  const [itemNo, setItemNo] = useState("")
  const [productName, setProductName] = useState("")
  const [productDescription, setProductDescription] = useState("")
  const [price, setPrice] = useState("")
  const [sellingPrice, setSellingPrice] = useState("")
  const [inventory, setInventory] = useState("")
  const [productfor, setProductfor] = useState("Normal")
  const [thumbnail, setThumbnail] = useState(null)
  const [thumbnailUrl, setThumbnailUrl] = useState(null)
  const [productImage, setProductImage] = useState(null)
  const [productImageUrl, setProductImageUrl] = useState(null)
  const [productImage1, setProductImage1] = useState(null)
  const [productImageUrl1, setProductImageUrl1] = useState(null)
  const [productImage2, setProductImage2] = useState(null)
  const [productImageUrl2, setProductImageUrl2] = useState(null)
  const [productImage3, setProductImage3] = useState(null)
  const [productImageUrl3, setProductImageUrl3] = useState(null)
  const [productImage4, setProductImage4] = useState(null)
  const [productImageUrl4, setProductImageUrl4] = useState(null)
  const [productImage5, setProductImage5] = useState(null)
  const [productImageUrl5, setProductImageUrl5] = useState(null)
  const [searchvalue, setSearchvalue] = useState("")

  const handlefile = (e, type) => {
    var file = e.target.files;

    if (file.length > 0 && file != null) {
      var reader = new FileReader();
      reader.readAsDataURL(file[0]);
      reader.onload = function (e) {
        if (type == "thumbnail") {
          setThumbnail(file[0])
          setThumbnailUrl(e.target.result)
        } else if (type == "productImage") {
          setProductImage(file[0])
          setProductImageUrl(e.target.result)
        } else if (type == "productImage1") {
          setProductImage1(file[0])
          setProductImageUrl1(e.target.result)
        } else if (type == "productImage2") {
          setProductImage2(file[0])
          setProductImageUrl2(e.target.result)
        } else if (type == "productImage3") {
          setProductImage3(file[0])
          setProductImageUrl3(e.target.result)
        } else if (type == "productImage4") {
          setProductImage4(file[0])
          setProductImageUrl4(e.target.result)
        } else if (type == "productImage5") {
          setProductImage5(file[0])
          setProductImageUrl5(e.target.result)
        }
      }
    } else {
      if (type == "thumbnail") {
        setThumbnail(null)
        setThumbnailUrl(null)
      } else if (type == "productImage") {
        setProductImage(null)
        setProductImageUrl(null)
      } else if (type == "productImage1") {
        setProductImage1(null)
        setProductImageUrl1(null)
      } else if (type == "productImage2") {
        setProductImage2(null)
        setProductImageUrl2(null)
      } else if (type == "productImage3") {
        setProductImage3(null)
        setProductImageUrl3(null)
      } else if (type == "productImage4") {
        setProductImage4(null)
        setProductImageUrl4(null)
      } else if (type == "productImage5") {
        setProductImage5(null)
        setProductImageUrl5(null)
      }

    }


  }

  const handleAddProduct = async () => {

    if (category == "") {
      toast.error("Please Select Category", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (itemNo == "") {
      toast.error("Please Enter Item No.", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productName == "") {
      toast.error("Please Enter Product Name", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productDescription == "") {
      toast.error("Please Enter Product Description", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (price == "") {
      toast.error("Please Enter Price", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (sellingPrice == "") {
      toast.error("Please Enter Selling Price", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (inventory == "") {
      toast.error("Please Enter Inventory", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (thumbnail == null) {
      toast.error("Please Select Thumbnail", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productImage == null) {
      toast.error("Please Select Product Image 1", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productImage1 == null) {
      toast.error("Please Select Product Image 2", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productImage2 == null) {
      toast.error("Please Select Product Image 3", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productImage3 == null) {
      toast.error("Please Select Product Image 4", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productImage4 == null) {
      toast.error("Please Select Product Image 5", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productImage5 == null) {
      toast.error("Please Select Product Image 6", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else {
      var formData = new FormData();
      formData.append("ProductCategory", category)
      formData.append("ItemNo", itemNo)
      formData.append("ProductName", productName)
      formData.append("ProductDescription", productDescription)
      formData.append("ProductColorCode", activeColorCode)
      formData.append("ProductSize", activeSize)
      formData.append("ProductPrice", price)
      formData.append("ProductSelling", sellingPrice)
      formData.append("ProductInventory", inventory)
      formData.append("ProductType", productType)
      formData.append("ProductFor", productfor)
      formData.append("Productthumbnail", thumbnail)
      formData.append("ProductImage", productImage)
      formData.append("ProductImage1", productImage1)
      formData.append("ProductImage2", productImage2)
      formData.append("ProductImage3", productImage3)
      formData.append("ProductImage4", productImage4)
      formData.append("ProductImage5", productImage5)

      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminAddProduct`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: formData
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          toast.success(response.message, {
            position: toast.POSITION.TOP_RIGHT
          })
          setModalAddProduct(false)
          setCategory("")
          setItemNo("")
          setProductName("")
          setProductDescription("")
          setPrice("")
          setSellingPrice("")
          setInventory("")
          setThumbnail(null)
          setThumbnailUrl(null)
          setProductImage(null)
          setProductImageUrl(null)
          setProductImage1(null)
          setProductImageUrl1(null)
          setProductImage2(null)
          setProductImageUrl2(null)
          setProductImage3(null)
          setProductImageUrl3(null)
          setProductImage4(null)
          setProductImageUrl4(null)
          setProductImage5(null)
          setProductImageUrl5(null)
          setProductfor("Normal")
          setActiveColorCode("#000000")
          setActiveSize("900mm")
          setEdit(false)
          getproduct()
        } else {
          toast.error(response.message, {
            position: toast.POSITION.TOP_RIGHT
          })
        }
      })
    }

  }
  const handleEditProduct = async () => {

    if (category == "") {
      toast.error("Please Select Category", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (itemNo == "") {
      toast.error("Please Enter Item No.", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productName == "") {
      toast.error("Please Enter Product Name", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (productDescription == "") {
      toast.error("Please Enter Product Description", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (price == "") {
      toast.error("Please Enter Price", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (sellingPrice == "") {
      toast.error("Please Enter Selling Price", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else if (inventory == "") {
      toast.error("Please Enter Inventory", {
        position: toast.POSITION.TOP_RIGHT
      })
    } else {
      var formData = new FormData();
      formData.append("ProductId", ProductId)
      formData.append("ProductCategory", category)
      formData.append("ItemNo", itemNo)
      formData.append("ProductName", productName)
      formData.append("ProductDescription", productDescription)
      formData.append("ProductColorCode", activeColorCode)
      formData.append("ProductSize", activeSize)
      formData.append("ProductPrice", price)
      formData.append("ProductSelling", sellingPrice)
      formData.append("ProductInventory", inventory)
      formData.append("ProductFor", productfor)
      formData.append("ProductType", productType)
      formData.append("Productthumbnail", thumbnail)
      formData.append("ProductImage", productImage)
      formData.append("ProductImage1", productImage1)
      formData.append("ProductImage2", productImage2)
      formData.append("ProductImage3", productImage3)
      formData.append("ProductImage4", productImage4)
      formData.append("ProductImage5", productImage5)

      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminUpdateProduct`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: formData
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          toast.success(response.message, {
            position: toast.POSITION.TOP_RIGHT
          })
          setModalAddProduct(false)
          setCategory("")
          setItemNo("")
          setProductName("")
          setProductDescription("")
          setPrice("")
          setSellingPrice("")
          setInventory("")
          setThumbnail(null)
          setThumbnailUrl(null)
          setProductImage(null)
          setProductImageUrl(null)
          setProductImage1(null)
          setProductImageUrl1(null)
          setProductImage2(null)
          setProductImageUrl2(null)
          setProductImage3(null)
          setProductImageUrl3(null)
          setProductImage4(null)
          setProductImageUrl4(null)
          setProductImage5(null)
          setProductImageUrl5(null)
          setProductType("fan")
          setProductfor("Normal")
          setProductId("")
          setActiveColorCode("#000000")
          setActiveSize("900mm")
          setEdit(false)
          getproduct()
        } else {
          toast.error(response.message, {
            position: toast.POSITION.TOP_RIGHT
          })
        }
      })
    }

  }

  const getproduct = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetProduct`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setProduct(response.data)
          setOriginalProduct(response.data) 
        } else {
          toast.error("No Product Found")
        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }
  }

  useEffect(() => {
    getproduct()
  }, [])

  const [packlist, setPackList] = useState([
    {
      value: "1",

    },
    {
      value: "2",

    }, {
      value: "4",

    },
    {
      value: "8",

    },
    {
      value: "10",

    },
    {
      value: "12",

    },
    {
      value: "15",

    }
  ])

  const getcolor = (color) => {
    if (color == "#000000") {
      return "Charcoal black"
    } else if (color == "#6d4d33") {
      return "Urban Oak"
    } else if (color == "#535353") {
      return "Midnight Grey"
    } else if (color == "#d8d8d8") {
      return "Arctic white"
    } else if (color == "#6d6d6d") {
      return "Ash grey"
    } else if (color == "#F0F0F0") {
      return "Noir white"
    } else if (color == "#A47141") {
      return "Caramel Brown"
    } else if (color == "#4A2413") {
      return "Cocoa Brown"
    } else if (color == "#F0F0F1") {
      return "Blanca Brown"
    } else if (color == "#8E8E8E") {
      return "Luxe Grey"
    } else {
      return "Classic Maroon"
    }
  }

  const getProductById = async (id) => {
    var data = product.filter((item) => {
      return item.ProductId == id
    })
    setProductId(id)
    setCategory(data[0].ProductCategory)
    setItemNo(data[0].ItemNo)
    setProductName(data[0].ProductName)
    setProductDescription(data[0].ProductDescription)
    setPrice(data[0].ProductPrice)
    setSellingPrice(data[0].ProductSelling)
    setInventory(data[0].ProductInventory)
    setThumbnailUrl(data[0].Productthumbnail)
    setProductImageUrl(data[0].ProductImage)
    setProductImageUrl1(data[0].ProductImage1)
    setProductImageUrl2(data[0].ProductImage2)
    setProductImageUrl3(data[0].ProductImage3)
    setProductImageUrl4(data[0].ProductImage4)
    setProductImageUrl5(data[0].ProductImage5)
    setProductType(data[0].ProductType || "fan")
    if (data[0].ProductType == "fan") {
      setSweepSize([{
        size: "900mm",
      }, {
        size: "1200mm",
      }, {
        size: "1400mm",
      }])
    } else if (data[0].ProductType == "exhaust") {
      setSweepSize([{
        size: "150mm",
      }, {
        size: "200mm",
      }, {
        size: "250mm",
      }])

    } else if (data[0].ProductType == "geyser") {
      setSweepSize([{
        size: "3L",
      }, {
        size: "5L",
      }])

    } else {
      setSweepSize([{
        size: "9W",
      }, {
        size: "10W",
      }, {
        size: "12W",
      }, {
        size: "20W",
      }, {
        size: "30W",
      }, {
        size: "40W",
      }])
    }
    setProductfor(data[0].ProductFor)
    setActiveColorCode(data[0].ProductColorCode)
    setActiveSize(data[0].ProductSize)
    setModalAddProduct(true)
    setEdit(true)
  }

  const search = async () => {
    if (searchvalue.length > 0) {
      var filteredData = originalProduct.filter((item) => {
        return item.ItemNo.toLowerCase().includes(searchvalue.toLowerCase()) || item.ProductName.toLowerCase().includes(searchvalue.toLowerCase()) || item.ProductInventory.toLowerCase().includes(searchvalue.toLowerCase())
      })
      setProduct(filteredData)
      setCurrentPage(1)
    } else {
      setProduct(originalProduct)
      setCurrentPage(1)
    }
  }

  const refreshData = async () => {
    setSearchvalue("");
    await getproduct();
    setCurrentPage(1);
    toast.success("Data refreshed successfully");
  }

  const handleDeleteProduct = async (id) => {
    await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminDeleteProduct`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        ProductId: id
      })
    }).then((res) => res.json()).then((response) => {
      if (response.status === 200) {
        toast.success(response.message, {
          position: toast.POSITION.TOP_RIGHT
        })
        setModalAddProduct(false)
        setEdit(false)
        getproduct()
      } else {
        toast.error(response.message, {
          position: toast.POSITION.TOP_RIGHT
        })
      }
    })
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); 
  const [showProduct, setShowProduct] = useState("fan")
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = product.filter((item) => item.ProductType === showProduct).slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <section className="dashbg-color">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="admin-filters">

              <div className="search-bar">
                <div className="search-container">
                  <form action="">
                    <input type="text" placeholder="Search by- Item No, Product Name" name="search" value={searchvalue} onChange={(e) => {
                      setSearchvalue(e.target.value)
                      if (e.target.value === '') {
                        setProduct(originalProduct)
                        setCurrentPage(1)
                      }
                    }} />
                    <button type="button" onClick={() => {
                      search()
                    }}><i className="fa fa-search"></i></button>
                  </form>
                </div>
              </div>

              <div className="filters d-flex">
                {/* <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                  <i className="fas fa-sync-alt"></i>
                </button> */}
                
                <button className="btn filter-pop" onClick={() => {
                  setCategory("")
                  setItemNo("")
                  setProductName("")
                  setProductDescription("")
                  setPrice("")
                  setSellingPrice("")
                  setInventory("")
                  setThumbnail(null)
                  setThumbnailUrl(null)
                  setProductImage(null)
                  setProductImageUrl(null)
                  setProductImage1(null)
                  setProductImageUrl1(null)
                  setProductImage2(null)
                  setProductImageUrl2(null)
                  setProductImage3(null)
                  setProductImageUrl3(null)
                  setProductImage4(null)
                  setProductImageUrl4(null)
                  setProductImage5(null)
                  setProductImageUrl5(null)
                  setProductfor("Normal")

                  setModalAddProduct(true);
                  setEdit(false);
                  if (showProduct === "fan") {
                    setActiveSize("900mm")
                    setSweepSize([{
                      size: "900mm",
                    }, {
                      size: "1200mm",
                    }, {
                      size: "1400mm",
                    }])
                    setProductType("fan")
                    setActiveColorCode("#000000")
                  } else if (showProduct === "exhaust") {
                    setActiveSize("150mm")
                    setSweepSize([{
                      size: "150mm",
                    }, {
                      size: "200mm",
                    }, {
                      size: "250mm",
                    }])
                    setProductType("exhaust")
                    setActiveColorCode("#000000")
                  } else if (showProduct === "geyser") {
                    setActiveSize("3L")
                    setSweepSize([{
                      size: "3L",
                    }, {
                      size: "5L",
                    }])
                    setProductType("geyser")
                    setCategory("geyser")
                    setActiveColorCode("#000000")
                  } else {
                    setActiveSize("9W")
                    setSweepSize([{
                      size: "9W",
                    }, {
                      size: "10W",
                    }, {
                      size: "12W",
                    }, {
                      size: "20W",
                    }, {
                      size: "30W",
                    }, {
                      size: "40W",
                    }])
                    setProductType("led-bulb")
                    setCategory("led-bulb")
                    setActiveColorCode("1")
                  }


                }}>
                  {showProduct === "fan" ? "Add Ceiling Fan" : showProduct === "led-bulb" ? "Add Led Bulb" : showProduct === "geyser" ? "Add Geyser" : "Add Exhaust Fan"}<i className="p-1 fa fa-add"></i></button>

                  <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                  <i className="fas fa-sync-alt"></i>
                </button>
              </div>

            </div>
            <div className="freeStyle">
              <button className={`btn  ${showProduct === "fan" ? "active" : ""}`} onClick={() => {
                setShowProduct("fan")
              }}>
                Ceiling Fan
              </button>
              <button className={`btn  ${showProduct === "exhaust" ? "active" : ""}`} onClick={() => {
                setShowProduct("exhaust")
              }}>Exhaust Fan </button>
              <button className={`btn  ${showProduct === "led-bulb" ? "active" : ""}`} onClick={() => {
                setShowProduct("led-bulb")
              }}>Led Bulb </button>
              <button className={`btn  ${showProduct === "geyser" ? "active" : ""}`} onClick={() => {
                setShowProduct("geyser")
              }}>Geyser</button>
            </div>
          </div>


          <div className="row justify-content-center">
            <div className="col-md-12 table-bg">
              <div style={{ backgroundColor: "" }}>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Item No.</th>
                        <th scope="col">Product Image</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Price</th>
                        <th scope="col">Selling Price</th>
                        <th scope="col">{showProduct === "led-bulb" ? "Power Consumption" : showProduct === "geyser" ? "Capacity" : "Sweep Sizes"}</th>
                        <th scope="col">{showProduct !== "led-bulb" ? "Colors" : "Pack of"}</th>
                        <th scope="col">Inventory</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>

                      {currentItems.filter((item) => item.ProductType === showProduct).length > 0 && currentItems.filter((item) => item.ProductType === showProduct).map((item, index) => {
                        return (
                          <tr key={index}>
                            <th scope="row">#{index + indexOfFirstItem + 1}</th>
                            <td>{item.ItemNo}</td>
                            <td><img src={item.Productthumbnail} className='imagethumbnail' /></td>
                            <td>{item.ProductName}</td>
                            <td>Rs. {item.ProductPrice}</td>
                            <td>Rs. {item.ProductSelling}</td>
                            <td>{item.ProductSize}</td>
                            <td>{showProduct !== "led-bulb" ? getcolor(item.ProductColorCode) : item.ProductColorCode}</td>
                            <td>{item.ProductInventory}</td>
                            <td><img src="assets/pen.svg" style={{ cursor: "pointer" }} onClick={() => {
                              getProductById(item.ProductId)
                            }} /></td>
                          </tr>
                        )
                      })
                      }
                      {currentItems.filter((item) => item.ProductType === showProduct).length == 0 && <tr>
                        <td colSpan="10" className="text-center">No Data Found</td>
                      </tr>}

                    </tbody>
                  </table>
                </div>
                {product.length > 0 ? <div className="row">
                  <div className="col-lg-12 text-center" style={{ position: "relative" }}>
                    <div className="pagination pagi">
                      {currentPage === 1 ? "" : <a href="javascript:void(0)" onClick={prevPage} disabled={currentPage === 1}>&laquo;</a>}

                      {Array.from({ length: Math.ceil(product.filter((item) => item.ProductType === showProduct).length / itemsPerPage) }).map((_, index) => (
                        <a href="javascript:void(0)" key={index}
                          onClick={() => goToPage(index + 1)}
                          className={currentPage === index + 1 ? "active" : ""}>{index + 1}</a>
                      ))}
                      {currentPage === Math.ceil(product.filter((item) => item.ProductType === showProduct).length / itemsPerPage) ? "" : <a href="javascript:void(0)" onClick={nextPage}
                        disabled={currentPage === Math.ceil(product.length / itemsPerPage)}>&raquo;</a>}

                    </div>
                    <div className="table-no-count">
                      Showing {Math.min(indexOfLastItem, product.filter((item) => item.ProductType === showProduct).length)} of {product.filter((item) => item.ProductType === showProduct).length} results
                    </div>
                  </div>
                </div> : ""}
              </div>
            </div>
          </div>
          <Modal
            show={modalAddProduct}
            size="lg"
            fullscreen={true}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header style={{ padding: "0px" }}>

              <div className="title mt-3 p-4 " style={{ backgroundColor: "white", color: "#19289F" }}>{edit ? "Update" : "Add"} {showProduct === "fan" ? "Ceiling Fan" : showProduct === "led-bulb" ? "Led Bulb" :showProduct === "geyser"?"Geyser": "Exhaust Fan"}</div>
              <button className="m-1 close-btn-pop" onClick={() => {
                setModalAddProduct(false)
              }}>Close</button>
            </Modal.Header>
            <Modal.Body>
              <div className="container containerproduct col-lg-12 d-flex align-content-center p-3 ">
                <div className="row">

                  <div className="left-cntnt mt-3 col-md-5 col-lg-6 m-2 p-4">

                    <div className="form-inner">
                      <div className="input-box">
                        <label className="details" >Choose Product Type:</label>
                        <select name='type' value={productType} onChange={(e) => {
                          setProductType(e.target.value);
                          if (e.target.value == "fan") {
                            setSweepSize([{
                              size: "900mm",
                            }, {
                              size: "1200mm",
                            }, {
                              size: "1400mm",
                            }])
                            setActiveSize("900mm")
                          }
                          if (e.target.value == "exhaust") {
                            setSweepSize([{
                              size: "150mm",
                            }, {
                              size: "200mm",
                            }, {
                              size: "250mm",
                            }])
                            setActiveSize("150mm")
                          }
                          if (e.target.value == "geyser") {
                            setSweepSize([{
                              size: "3L",
                            }, {
                              size: "5L",
                            }])
                            setActiveSize("3L")
                          }
                          if (e.target.value == "led-bulb") {
                            setSweepSize([{
                              size: "9W",
                            }, {
                              size: "10W",
                            }, {
                              size: "12W",
                            }, {
                              size: "20W",
                            }, {
                              size: "30W",
                            }, {
                              size: "40W",
                            }])
                            setActiveSize("9W")
                            setActiveColorCode(1)
                          }
                        }} required>
                          <option value="">Select Type</option>
                          <option value="fan">Fan</option>
                          <option value="exhaust">Exhaust</option>
                          <option value="led-bulb">Led Bulb</option>
                          <option value="geyser">Geyser</option>
                        </select>
                      </div>
                      {productType == "fan" || productType == "exhaust" ? <div className="input-box">
                        <label className="details" >Choose Product Category:</label>
                        {productType == "fan" ? <>
                          <select name='category' value={category} onChange={(e) => {
                            setCategory(e.target.value)
                          }} required>
                            <option value="">Select Category</option>
                            <option value="Helix">Helix</option>
                            <option value="Knoxx">Knoxx</option>
                            <option value="Stella">Stella</option>
                            <option value="Knoxx-Quad">Knoxx-Quad</option>
                            <option value="Stella-Quad">Stella-Quad</option>
                            <option value="Prizma">Prizma</option>
                          </select>
                        </>
                          : productType == "exhaust" ? <>
                            <select name='category' value={category} onChange={(e) => {
                              setCategory(e.target.value)
                            }} required>
                              <option value="">Select Category</option>
                              <option value="ecoz">ECOZ</option>
                              <option value="ecoz_turbo">ECOZ Turbo</option>

                            </select>
                          </> : ""
                        }

                      </div> : ""}
                      <div className="input-box">
                        <label className="details" >Item No.</label>
                        <input type="" placeholder="" required value={itemNo} disabled={edit} onChange={(e) => {
                          setItemNo(e.target.value)
                        }} />
                      </div>
                      <div className="input-box">
                        <label className="details">Product Name:</label>
                        <input type="" placeholder="" required value={productName} onChange={(e) => {
                          setProductName(e.target.value)
                        }} />
                      </div>
                      <div className="input-box">
                        <label className="details">Product Description:</label>
                        <textarea name="" id="" rows="3" placeholder="" required value={productDescription} onChange={(e) => {
                          setProductDescription(e.target.value)
                        }}></textarea>
                      </div>
                      <div className="input-box price-pop">
                        <div className="price ">
                          <label className="details">Prices</label>
                          <input type="number" value={price} onChange={(e) => {
                            setPrice(e.target.value)
                          }} />
                        </div>
                        <div className="price">
                          <label className="details">Selling Prices:</label>
                          <input type="number" value={sellingPrice} onChange={(e) => {
                            setSellingPrice(e.target.value)
                          }} />
                        </div>
                      </div>

                      <div className="input-box">
                        <label className="details">{productType == "fan" || productType == "exhaust" ? "Sweep Size" : productType == "geyser" ? "Capacity" : "Power Consumption"}:</label>
                        <div className="btn" style={{
                          display: "flex"
                        }}>
                          {sweepSize.map((item, index) => {
                            return (
                              <button type="button" className={activeSize == item.size ? "btnstyleactive m-1" : "btnstyle m-1"} onClick={() => handleSize(item.size)} key={index}>{item.size}</button>
                            )
                          })
                          }

                        </div>
                      </div>

                      <div className="input-box">
                        <label className="details">{productType === "fan" || productType === "exhaust" || productType === "geyser" ? "Colors" : "Pack Of"}:</label>
                        <div className="d-flex mt-3 flex-wrap">
                          {productType === "fan"  ? <>{colorPallete.map((item, index) => {
                            return (
                              <div className="color-btn d-block" onClick={() => handlecolor(item.colorCode)} key={index}>
                                <div className="btn1" ><button style={{
                                  transform: "rotate(90deg)",
                                  background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.colorCode} 180deg 360deg)`, marginTop: "5px"
                                }}>
                                  {activeColorCode == item.colorCode ? <i className={item.secondary == "#000000" ? "fa fa-check text-light" : "fa fa-check text-dark"} style={{ transform: "rotate(274deg)" }}></i> : null}

                                </button>
                                </div>
                                <label >{item.color.split(" ")[0]}<br />{item.color.split(" ")[1]}</label>
                              </div>
                            )
                          })
                          }</> : productType === "exhaust" || productType === "geyser" ? <>
                            {colorlist.map((item, index) => {
                              return (
                                <div className="color-btn d-block" onClick={() => handlecolor(item.colorCode)} key={index}>
                                  <div className="btn1" ><button style={{
                                    transform: "rotate(90deg)",
                                    background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.colorCode} 180deg 360deg)`, marginTop: "5px"
                                  }}>
                                    {activeColorCode == item.colorCode ? <i className={item.secondary == "#000000" ? "fa fa-check text-light" : "fa fa-check text-dark"} style={{ transform: "rotate(274deg)" }}></i> : null}

                                  </button>
                                  </div>
                                  <label >{item.color.split(" ")[0]}<br />{item.color.split(" ")[1]}</label>
                                </div>
                              )
                            })
                            }
                          </> : <>
                            <div className="btn" style={{
                              display: "flex",
                              flexWrap: "wrap"
                            }}>
                              {packlist.map((item, index) => {
                                return (
                                  <button type="button" style={{
                                    padding: "5px 10px"
                                  }} className={activeColorCode == item.value ? "btnstyleactive m-1" : "btnstyle m-1"} onClick={() => handlecolor(item.value)} key={index}>{item.value}</button>
                                )
                              })
                              }
                            </div>
                          </>}


                        </div>


                      </div>

                      <div className="input-box mt-4">
                        <span className="details">Inventory:</span>
                        <input type="number" placeholder="" required value={inventory} onChange={(e) => {
                          setInventory(e.target.value)
                        }} />
                      </div>
                    </div>

                  </div>

                  <div className="right-cntnt mt-3 col-md-6 col-lg-5 p-2 block">
                    <form action="#" className="mt-3 p-3">
                      <div className="radio form-inner d-flex">
                        <span className="details">Images for:</span>

                        {productType === "fan" && <div className="form-check form-check-inline">
                          <input className="form-check-input m-sm-1" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Dark Edition" disabled={activeColorCode !== "#000000" ? true : false} checked={productfor == "Dark Edition" ? true : false} onClick={() => {
                            setProductfor("Dark Edition")
                          }} readOnly />
                          <label className="form-check-label" for="inlineRadio1">Dark Edition</label>
                        </div>
                        }
                        <div className="form-check form-check-inline">
                          <input className="form-check-input m-sm-1" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="Normal" checked={productfor == "Normal" ? true : false} onClick={() => {
                            setProductfor("Normal")
                          }} />
                          <label className="form-check-label" for="inlineRadio2">Normal</label>
                        </div>

                      </div>
                      <div className=" mt-3">
                        <label className="details">Thumbnail:</label>
                        <div className="d-flex ">
                          <img src={thumbnailUrl != null ? thumbnailUrl : "./assets/none.svg"} className="img-fluid imagethumbnail" />
                          <div className="mb-3 m-lg-2">
                            <label for="formFile" className="form-label"></label>
                            <input className="form-control" type="file" id="formFile" onChange={(e) => {
                              handlefile(e, "thumbnail")
                            }} />
                            <p className="text-secondary mt-2"></p>
                          </div>
                        </div>

                      </div>
                      <div className="mt-3">
                        <span className="details">Product images:</span>
                        <div className="mt-2 d-flex">
                          <img src={productImageUrl != null ? productImageUrl : "./assets/none.svg"} className="img-fluid imagethumbnail" />
                          <div className="mb-2 m-lg-2">
                            <label for="formFile" className="form-label"></label>
                            <input className="form-control" type="file" id="formFile1" onChange={(e) => {
                              handlefile(e, "productImage")
                            }} />
                            <p className="text-secondary mt-2"></p>
                          </div>
                        </div>

                        <div className="d-flex">
                          <img src={productImageUrl1 != null ? productImageUrl1 : "./assets/none.svg"} className="img-fluid imagethumbnail" />
                          <div className="mb-2 m-lg-2">
                            <label for="formFile" className="form-label"></label>
                            <input className="form-control" type="file" id="formFile2" onChange={(e) => {
                              handlefile(e, "productImage1")
                            }} />
                            <p className="text-secondary mt-2"></p>
                          </div>
                        </div>

                        <div className="d-flex">
                          <img src={productImageUrl2 != null ? productImageUrl2 : "./assets/none.svg"} className="img-fluid imagethumbnail" />
                          <div className="mb-2 m-lg-2">
                            <label for="formFile" className="form-label"></label>
                            <input className="form-control" type="file" id="formFile3" onChange={(e) => [
                              handlefile(e, "productImage2")

                            ]} />
                            <p className="text-secondary mt-2"></p>
                          </div>
                        </div>

                        <div className="d-flex">
                          <img src={productImageUrl3 != null ? productImageUrl3 : "./assets/none.svg"} className="img-fluid imagethumbnail" />
                          <div className="mb-2 m-lg-2">
                            <label for="formFile" className="form-label"></label>
                            <input className="form-control" type="file" id="formFile4" onChange={(e) => [
                              handlefile(e, "productImage3")

                            ]} />
                            <p className="text-secondary mt-2"></p>
                          </div>
                        </div>

                        <div className="d-flex">
                          <img src={productImageUrl4 != null ? productImageUrl4 : "./assets/none.svg"} className="img-fluid imagethumbnail" />
                          <div className="mb-2 m-lg-2">
                            <label for="formFile" className="form-label"></label>
                            <input className="form-control" type="file" id="formFile5" onChange={(e) => [
                              handlefile(e, "productImage4")

                            ]} />
                            <p></p>
                          </div>

                        </div>

                        <div className="d-flex">
                          <img src={productImageUrl5 != null ? productImageUrl5 : "./assets/none.svg"} className="img-fluid imagethumbnail" />
                          <div className="mb-2 m-lg-2">
                            <label for="formFile" className="form-label"></label>
                            <input className="form-control" type="file" id="formFile6" onChange={(e) => [
                              handlefile(e, "productImage5")

                            ]} />
                            <p></p>
                          </div>

                        </div>



                      </div>
                    </form>


                    <div className="col-lg-12 mb-3 ">
                      <div className="right-btn">
                        <button className="border-danger text-danger m-1" onClick={() => {
                          handleDeleteProduct(ProductId)
                        }}>Delete</button>
                        <button className="m-1" onClick={() => {
                          setModalAddProduct(false)
                        }}>Cancel</button>
                        <button className="m-1" onClick={() => {
                          edit ? handleEditProduct() : handleAddProduct()
                        }}>{edit ? "Update" : "Add"}</button>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </Modal.Body>
          </Modal>
        </div>
      </section>
    </>
  )
}
export default Productmgmt;
